import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ResponseError } from '@clickersphere/core/entities/ResponseError';
import BillingService from '@clickersphere/core/services/BillingService';
import { errorsCode } from '@clickersphere/core/utils/consts/errorsCode';
import useToast from '../useToast';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { SUBSCRIPTION_QUERY_KEY } from './useSubscription';

export function useReactivateSubscription() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();
  const { toast } = useToast();
  const { t } = useTranslation();

  const { isPending: reactivateIsPending, mutateAsync: reactivateAsync } =
    useMutation({
      mutationFn: () => BillingService.reactivateSubscription(),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: buildQueryKey(SUBSCRIPTION_QUERY_KEY),
        });
        toast(t('billing.toasts.reactivateSuccess'), 'success');
      },
      onError: (error) => {
        if (error instanceof ResponseError && error.code in errorsCode) {
          const key = error.code as keyof typeof errorsCode;
          toast(t(errorsCode[key]), 'error');
          return;
        }
        toast(t('billing.toasts.reactivateError'), 'error');
      },
    });

  return {
    reactivateAsync,
    reactivateIsPending,
  };
}
